import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { useCallback, useState } from "react";

import language24Icon from "img/ic_language24.svg";

import LanguageModalContent from "./LanguageModalContent";
import ModalWithPortal from "../Modal/ModalWithPortal";
import "./NetworkDropdown.scss";

export default function LanguagePopupHome() {
  useLingui();
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);

  const handleLanguageModalClose = useCallback(() => {
    setIsLanguageModalOpen(false);
  }, []);

  return (
    <>
      <button
        type="button"
        className="App-header-network App-header-language"
        onClick={() => setIsLanguageModalOpen(true)}
        aria-label={t`Select Language`}
      >
        <img className="network-dropdown-icon" src={language24Icon} alt="" />
      </button>

      <ModalWithPortal
        className="language-popup"
        isVisible={isLanguageModalOpen}
        setIsVisible={setIsLanguageModalOpen}
        label={t`Select Language`}
        description={t`Choose your language. Automatic uses your browser and, after wallet connection, your region.`}
      >
        <LanguageModalContent onClose={handleLanguageModalClose} />
      </ModalWithPortal>
    </>
  );
}
